import { QUESTIONS, ownerInfoKeys, vehicleInfoKeys } from '../constants/steps'
import { Button } from 'components/ui'
import { useDispatch, useSelector } from 'react-redux'
import { setWarranty, setWarrantyData } from '../store/dataSlice'
import { apiCreateCustomer, apiCreateWarranty } from 'services/LoveWarrantyServices'
import { initialOwnerInfo } from '../constants/intialValues'
import { popNotification } from '..'
import { formatCurrency } from 'utils/helpers'

const NEXT_STEP = 4

export const Review = ({ setStep }) => {
    const dispatch = useDispatch()
    const { ownerInfo, productData, vehicleInfo, warrantyData, searchUser } = useSelector((state) => state.createWarranty.data)
    const sessionUser = useSelector(
        (state) => state.auth.user
    )

    console.log(sessionUser);


    const createWarranty = async (updatedWarrantyData) => {
        let warranty

        if (!warrantyData.customer_id) warranty = await apiCreateWarranty(updatedWarrantyData)
        else warranty = await apiCreateWarranty(warrantyData)

        // create warranty
        if (warranty && warranty.status === 201) {
            dispatch(setWarranty(warranty.data))
            return {
                error: false,
                message: 'Draft saved',
                data: warranty.data
            }
        }
    }

    const saveDraft = async () => {
        try {
            // check if customer_id is set in warrantyData
            if (warrantyData.customer_id) {
                // create warranty
                const warranty = await createWarranty(warrantyData)
                return warranty
            }

            // create customer
            if (ownerInfo && ownerInfo !== initialOwnerInfo) {
                // create customer
                const owner = await apiCreateCustomer(ownerInfo)

                if (owner && owner.data) {
                    dispatch(setWarrantyData({
                        ...warrantyData,
                        customer_id: owner.data.id
                    }))

                    let updatedWarrantyData = {
                        ...warrantyData,
                        customer_id: owner.data.id
                    }


                    // create warranty
                    const warranty = await createWarranty(updatedWarrantyData)
                    return warranty
                }
            }
        } catch (err) {
            return {
                error: true,
                message: err.response.data.message
            }
        }
    }

    const handleContinue = async () => {
        const resp = await saveDraft()

        if (resp.error) {
            popNotification(resp.message)
            return
        }
        setStep(NEXT_STEP)
    }

    return (
        <div className='flex items-center justify-center flex-col w-full mx-auto px-6 h-full'>
            <h2 className="text-2xl font-bold text-black text-left w-full">Guarantee Overview</h2>
            <span className="text-black w-full mt-2 text-left">Please check if all the information is correct. If you're happy with the details and your plan, please continue to payment processing</span>

            <div className="flex flex-col w-full mt-8">
                <div className="flex justify-between w-full items-center">
                    <h2 className="text-2xl font-semibold text-black">Product Details</h2>
                </div>

                <div className="grid grid-cols-3 w-full mt-4 text-black ">
                    <span className="col-span-2"><i className='mr-2 fas fa-flag' /> Coverage:</span>
                    <span className="">{productData.name}</span>
                </div>
                <div className="grid grid-cols-3 w-full mt-4 text-black ">
                    <span className="col-span-2"><i className='mr-2 fas fa-calendar-day' /> Excess:</span>
                    <span className="">{formatCurrency(productData.excess)}</span>
                </div>
                <div className="grid grid-cols-3 w-full mt-4 text-black ">
                    <span className="col-span-2"><i className='mr-2 fas fa-calendar-day' /> Policy start date:</span>
                    <span className="">{warrantyData.valid_from}</span>
                </div>
                <div className="grid grid-cols-3 w-full mt-4 text-black ">
                    <span className="col-span-2"><i className='mr-2 fas fa-calendar-day' /> Policy Duration:</span>
                    <span className="">{productData.duration_months}</span>
                </div>
                <div className="grid grid-cols-3 w-full mt-4 text-black ">
                    <span className="col-span-2"><i className='mr-2 fas fa-calendar-day' /> Policy End date:
                    </span>
                    <span className="">{
                        new Date(new Date(warrantyData.valid_from).setMonth(new Date(warrantyData.valid_from).getMonth() + productData.duration_months)).toISOString().split('T')[0]
                    }</span>
                </div>
                <div className="grid grid-cols-3 w-full mt-4 text-black ">
                    <span className="col-span-2"><i className='mr-2 fas fa-sterling-sign' /> Claim limit:</span>
                    <span className="">{formatCurrency(productData.claim_limit)}</span>
                </div>
                <div className="grid grid-cols-3 w-full mt-4 text-black ">
                    <span className="col-span-2"><i className='mr-2 fas fa-calendar' /> Created on:</span>
                    <span className="">{new Date().toISOString().split('T')[0]}</span>
                </div>
                <div className="grid grid-cols-3 w-full mt-4 text-black ">
                    <span className="col-span-2"><i className='mr-2 fas fa-user' /> Created by:</span>
                    <span className="">{sessionUser.first_name} {sessionUser.last_name}</span>
                </div>
            </div>

            <div className="flex flex-col w-full mt-8">
                <div className="flex justify-between w-full items-center">
                    <h2 className="text-2xl font-semibold text-black">Customer information</h2>
                    {!searchUser.found && (
                        <button
                            className="bg-custom-900 rounded-md text-black text-center px-4 py-2 hover:cursor-pointer"
                            type='button'
                            onClick={() => setStep(1)}>
                            Edit
                        </button>
                    )}
                </div>
                {Object.entries(ownerInfo).map((item, index) => (
                    ownerInfoKeys[item[0]] && (
                        <div className="grid grid-cols-3 w-full mt-4 text-black  " key={index}>
                            <span className="col-span-2"><i className={`mr-2 fas ${ownerInfoKeys[item[0]].icon}`} /> {ownerInfoKeys[item[0]].label}: </span>
                            <span className="">{item[1] ? item[1] : '-'}</span>
                        </div>
                    )
                ))}
            </div>

            <div className="flex flex-col w-full mt-8">
                <div className="flex justify-between w-full items-center">
                    <h2 className="text-2xl font-semibold text-black">Vehicle information</h2>
                    <button
                        className="bg-custom-900 rounded-md text-black text-center px-4 py-2 hover:cursor-pointer"
                        type='button'
                        onClick={() => setStep(0)}>
                        Edit
                    </button>
                </div>
                {Object.entries(vehicleInfo).map((item, index) => (
                    vehicleInfoKeys[item[0]] && (
                        <div className="grid grid-cols-3 w-full mt-4 text-black  " key={index}>
                            <span className="col-span-2"><i className={`mr-2 fas ${vehicleInfoKeys[item[0]].icon}`} />  {vehicleInfoKeys[item[0]].label}: </span>

                            <span className="">{item[1] ? item[1] : '-'}</span>
                        </div>
                    )
                ))}
                {Object.entries(warrantyData).map((item, index) => (
                    vehicleInfoKeys[item[0]] && (
                        <div className="grid grid-cols-3 w-full mt-4 text-black  " key={index}>
                            <span className="col-span-2"><i className={`mr-2 fas ${vehicleInfoKeys[item[0]].icon}`} />  {vehicleInfoKeys[item[0]].label}: </span>
                            <span className="">{item[1] ? item[1] : '-'}</span>
                        </div>
                    )
                ))}
            </div>

            <div className="flex flex-col w-full mt-8">
                <div className="flex justify-between w-full items-center">
                    <h2 className="text-2xl font-semibold text-black">Qualification</h2>
                    <button
                        className="bg-custom-900 rounded-md text-black text-center px-4 py-2 hover:cursor-pointer"
                        type='button'
                        onClick={() => setStep(0)}>
                        Edit
                    </button>
                </div>

                {QUESTIONS.map((item, index) => (
                    <div className="grid grid-cols-4 w-full mt-4 text-black   gap-5" key={index}>
                        <span className="w-full col-span-3">{item.question}</span>
                        <span className="capitalize flex gap-2 items-center">
                            {/* <span className={`w-2 h-2 rounded-full ${item.expected === 'yes' ? 'bg-green-500' : 'bg-custom-300'}`}></span> */}
                            <i className={`fas fa-${item.expected === 'yes' ? 'check' : 'times'} text-md ${item.expected === 'yes' ? 'text-green-500' : 'text-red-500'}`}></i>
                            {item.expected}
                        </span>
                    </div>
                ))}
            </div>

            <div className="text-right w-full pt-16 flex justify-between">
                <Button
                    type="button"
                    className="!text-black"
                    color="custom-900"
                    variant="solid"
                    onClick={() => { setStep(2) }}
                >
                    Back
                </Button>

                <Button
                    onClick={handleContinue}
                    type="submit"
                    variant="solid">
                    Next
                </Button>
            </div>
        </div>
    )
}

